import moment from 'moment'
import { dateToShow, dateToMysql } from '@/helpers/dates'
import { get, filter, map, find, isEmpty } from 'lodash'
import { status } from './dataStatus'

const beforeDate = search => {
  if (isEmpty(search.date_start) && isEmpty(search.date_end)) {
    search.dateIsBefore = false
    return search
  }
  if (!isEmpty(search.date_start) && !isEmpty(search.date_end)) {
    const isAfter = moment(dateToMysql(search.date_end)).isSameOrAfter(dateToMysql(search.date_start))

    if (isAfter) {
      search.dateIsBefore = false
    } else {
      search.dateIsBefore = true
    }
  }

  return search
}

const prepareSearch = search => {
  search.date_start = dateToMysql(search.date_start, 'YYYY-MM-DD 00:00:00')
  search.date_end = dateToMysql(search.date_end, 'YYYY-MM-DD 23:59:59')

  return search
}

const prepareShow = schedule => {
  schedule._selected = false
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.date = dateToShow(schedule.date).slice(0, 5)
  // Existindo agendamento transferido
  if (schedule.transfer) {
    schedule.transfer.date = dateToShow(schedule.transfer.date).slice(0, 5)
  }

  if (schedule.agenda.professional.name.length > 30) {
    schedule.agenda.professional.name = schedule.agenda.professional.name.slice(0, 30) + ' ...'
  } else {
    schedule.agenda.professional.name = schedule.agenda.professional.name
  }

  if (schedule.patient.name.length > 30) {
    schedule.patient.name = schedule.patient.name.slice(0, 30) + ' ...'
  } else {
    schedule.patient.name = schedule.patient.name
  }

  schedule._status = get(status, schedule.status, schedule.status)

  return schedule
}

export default {

  onSelectedRunAction (action, schedule = {}) {
    // Definindo como Atrasado
    if (action === 'delayed') {
      this.schedulesSelected = [{...schedule}]
      this.showModalDelayed = true
    }

    // RallBack para Agendado
    if (action === 'scheduled') {
      this.schedulesSelected = [{...schedule}]
      this.showModalFromDelayedRollback = true
    }

    // Definindo como Atendido
    if (action === 'attended') {
      this.schedulesSelected = [{...schedule}]
      this.showModalConfirmed = true
    }

    // Definindo como Ausente
    if (action === 'absent') {
      this.schedulesSelected = [{...schedule}]
      this.showModalAbsent = true
    }

    // Defindindo como Cancelado
    if (action === 'canceled') {
      this.schedulesSelected = [{...schedule}]
      this.showModalCancel = true
    }

    // Definindo em Atendimento
    if (action === 'in_attendance') {
      this.schedulesSelected = [{...schedule}]
      this.showModalInAttendance = true
    }

    // definindo como present
    if (action === 'present') {
      this.schedulesSelected = [{...schedule}]
      this.showModalPresent = true
    }
  },

  onSelectedAction (actions) {
    // cancellation actions
    if (actions === 'canceled') {
      this.doCancel()
    }
    // absents ações definir como stutus ausente
    if (actions === 'absent') {
      this.doAbsent()
    }
    // attended action
    if (actions === 'attended') {
      this.doConfirmed()
    }
    // delayed action
    if (actions === 'delayed') {
      this.doDelayed()
    }

    // in_attendance action
    if (actions === 'in_attendance') {
      this.doInAttendance()
    }

    // present action
    if (actions === 'present') {
      this.doPresent()
    }
  },
  prepareShow,
  prepareSearch,
  doLoadAll (searchActive) {
    const befodeDate = beforeDate(this.search)
    if (befodeDate.dateIsBefore) {
      this.showBeforeDate = true
      return false
    }

    if (searchActive) {
      this.$v.$touch()
      if (this.$v.$error) {
        return
      }
    }

    const search = {
      includes: this.includes,
      ...this.defaultSearch,
      ...this.search
    }

    this.loading = true
    this.$resource.get('', this.prepareSearch(search))
      .then(({data, meta}) => {
        this[this.entities] = map(data, this.prepareShow)
        this.afterPrepareShow()
        this.pagination = meta.pagination
        this.loading = false
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  selectAll () {
    const schedules = map(this.schedules, schedule => {
      if (schedule.status !== 'canceled') {
        schedule._selected = this.all
      }

      return schedule
    })

    this.schedules = [...schedules]
  },
  onCloseCancel (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalCancel = false
    this.all = false
  },

  onCloseFromFromDelayedRollback () {
    this.showModalFromDelayedRollback = false
  },
  onCloseRollback (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalRollback = false
    this.all = false
  },
  // Confirmando como atendido
  onCloseConfirmed (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalConfirmed = false
    this.all = false
  },

  onCloseReverser (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalReverser = false
  },

  onCloseTransfer (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalTransfer = false
  },
  onCloseAbsent (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalAbsent = false
  },

  onCloseDelayed () {
    this.showModalDelayed = false
  },

  onCloseInAttendance () {
    this.showModalInAttendance = false
  },

  onClosePresent () {
    this.showModalPresent = false
  },
  // Cancelando
  doCancel (schedule = {}, all = true) {
    if (all) {
      this.schedulesSelected = this.schedules.filter((schedule) => {
        return schedule._selected
      })
    } else {
      this.schedulesSelected = [{...schedule}]
    }
    this.showModalCancel = true
  },

  doRollback (schedule = {}, all = true) {
    if (all) {
      this.schedulesSelected = this.schedules.filter((schedule) => {
        return schedule._selected
      })
    } else {
      this.schedulesSelected = [{...schedule}]
    }
    this.showModalRollback = true
  },

  // Confirmando todos
  doConfirmed (schedule = {}, all = true) {
    if (all) {
      this.schedulesSelected = this.schedules.filter((schedule) => {
        return schedule._selected
      })
    } else {
      this.schedulesSelected = [{...schedule}]
    }
    this.showModalConfirmed = true
  },

  // show modal for delayed item
  doDelayed (schedule = {}, all = true) {
    if (all) {
      this.schedulesSelected = this.schedules.filter((schedule) => {
        return schedule._selected
      })
    } else {
      this.schedulesSelected = [{...schedule}]
    }
    this.showModalDelayed = true
  },

  // Definindo status como ausente
  doAbsent (schedule = {}, all = true) {
    if (all) {
      this.schedulesSelected = this.schedules.filter((schedule) => {
        return schedule._selected
      })
    } else {
      this.schedulesSelected = [{...schedule}]
    }
    this.showModalAbsent = true
  },

  // Revetendo
  doReverser (schedule) {
    this.currentSchedule = {...schedule}
    this.showModalReverser = true
  },

  // Transferindo
  doTransfer (schedule) {
    this.currentSchedule = {...schedule}
    this.showModalTransfer = true
  },
  hideShowModalRollback () {
    this.showModalRollback = false
  },
  hideShowModalFromDelayedRollback () {
    this.showModalFromDelayedRollback = false
  },
  hideShowModalCancel () {
    this.showModalCancel = false
  },
  hideShowModalReverser () {
    this.showModalReverser = false
  },
  hideShowModalTransfer () {
    this.showModalTransfer = false
  },
  hideshowModalConfirmed () {
    this.showModalConfirmed = false
  },
  hideShowModalAbsent () {
    this.showModalAbsent = false
  },
  hideShowModalDelayed () {
    this.showModalDelayed = false
  },
  hideShowModalInAttendance () {
    this.showModalInAttendance = false
  },
  hideShowModalPresent () {
    this.showModalPresent = false
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/methods.js